import { SERVER } from "./constants";

// inject the schemas
export const injectLandingPageOrganizationSchema = () => {
  if (SERVER === "production") {
    // 1. Create the script element
    const ldJsonScript = document.createElement("script");
    ldJsonScript.type = "application/ld+json";
    ldJsonScript.id = "organization-schema"; // so we can find/remove it later

    // 2. Populate it with your JSON‑LD
    ldJsonScript.text = JSON.stringify({
      "@context": "https://schema.org/",
      "@type": "Organization",
      "@id ": "#Organization",
      url: "https://www.equityprotect.com/",
      legalName: "EquityProtect Inc.",
      name: "EquityProtect",
      description:
        "EquityProtect provides proactive home title and equity protection through its patented SmartPolicy technology, offering 24/7 monitoring, blocking unauthorized transfers, and a $1,000,000 guarantee for covered unauthorized transfers.",
      image: "",
      logo: "https://www.equityprotect.com/static/media/ep_new.a9707e0cd2cc7bf35989142d618e2e87.svg",
      telephone: "+1-888-213-2959",
      email: "support@equityprotect.com",
      contactPoint: {
        "@type": "ContactPoint",
        telephone: "+1-866-327-1484",
        contactType: "customer service",
        areaServed: "US",
        availableLanguage: ["English"],
      },
      address: {
        "@type": "PostalAddress",
        streetAddress: "5566 Longley Ln Suite B",
        addressLocality: "Reno",
        addressRegion: "NV",
        addressCountry: "US",
        postalCode: "89511",
      },
      serviceArea: {
        "@type": "Country",
        name: "United States",
      },
      sameAs: [
        "https://www.facebook.com/people/EquityProtect/100090626499488/",
        "https://www.instagram.com/equity.protect/",
        "https://www.youtube.com/@equityprotect",
        "https://www.linkedin.com/company/equity-protect",
        "https://www.bbb.org/us/nv/reno/profile/real-estate/equityprotectcom-1166-90044397",
      ],
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "Home Title Protection Services",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Home Title Monitoring",
              description:
                "Monitors property records 24/7 and alerts homeowners of unauthorized changes.",
            },
            priceCurrency: "USD",
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Title Theft Fraud Protection",
              description:
                "Provides an extra layer of security against title fraud and unauthorized ownership transfers.",
            },
            priceCurrency: "USD",
          },
        ],
      },
    });

    // 3. Append it to head (or wherever you prefer)
    document.head.appendChild(ldJsonScript);
  }
};

export const injectPricingPageProductSchema = () => {
  if (SERVER === "production") {
    // 1. Create the script element
    const ldJsonScript = document.createElement("script");
    ldJsonScript.type = "application/ld+json";
    ldJsonScript.id = "product-schema"; // so we can find/remove it later

    // 2. Populate it with your JSON‑LD
    ldJsonScript.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Product",
      image:
        "https://www.equityprotect.com/static/media/ep_new.a9707e0cd2cc7bf35989142d618e2e87.svg",
      name: "Home Title Theft Protection & Home Title Fraud Monitoring Services",
      description:
        "EquityProtect offers Home Equity Protection from home title theft and title fraud with 24/7 Title Monitoring services, Urgent Fraud Alerts, Title Restoration, and more. EquityProtect is a real estate consultant and software company with a patented SmartPolicy, protecting your home ownership from cybercriminals and fraud with the highest data security standards and blockchain protection. Our title theft company provides affordable title lock protection for homeowners and real estate investors across the United States with monthly and yearly plans to protect against fraud of home property investments and real estate assets. Contact us at (866) 327-1484 today to learn about our technology, programs, pricing, protection, and more.",
      brand: "Equity Protect",
      offers: {
        "@type": "AggregateOffer",
        url: "https://www.equityprotect.com/",
        priceCurrency: "USD",
        lowPrice: "19.99",
      },
      review: {
        "@type": "Review",
        name: "Chris Kligora",
        reviewBody:
          "Finally, a company that actually protects your most significant asset. I had another service for years, and all of the alerts they sent were six months or more after the change happened. When I heard about Equity Protect, it was a simple decision for me, I canceled service with HTL and signed up for EP service.",
        reviewRating: {
          "@type": "Rating",
          ratingValue: "5",
        },
        author: { "@type": "Person", name: " Chris Kligora" },
        publisher: { "@type": "Organization", name: "Google" },
      },
    });

    // 3. Append it to head (or wherever you prefer)
    document.head.appendChild(ldJsonScript);
  }
};

export const injectRatingSchema = () => {
  if (SERVER === "production") {
    // 1. Create the script element
    const ldJsonScript = document.createElement("script");
    ldJsonScript.type = "application/ld+json";
    ldJsonScript.id = "rating-schema"; // so we can find/remove it later

    // 2. Populate it with your JSON‑LD
    ldJsonScript.text = JSON.stringify({
      "@context": "https://schema.org/",
      "@type": "Product",
      name: "Bonnie W",
      image:
        "https://www.equityprotect.com/static/media/equity.425de9cf932b9969560b.WebP",
      brand: {
        "@type": "Brand",
        name: "EquityProtect",
      },
      offers: {
        "@type": "AggregateOffer",
        url: "https://www.equityprotect.com/",
        priceCurrency: "USD",
        lowPrice: "",
      },
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: "5",
        bestRating: "5",
        worstRating: "0",
        ratingCount: "14",
        reviewCount: "14",
      },
      review: {
        "@type": "Review",
        name: "Bonnie W",
        reviewBody:
          "My goal in August 2023 was to find a company that would prevent deed fraud rather than just monitor it.",
        reviewRating: {
          "@type": "Rating",
          ratingValue: "5",
          bestRating: "5",
          worstRating: "0",
        },
        datePublished: "2025-07-08",
        author: { "@type": "Person", name: "Bonnie W" },
        publisher: { "@type": "Organization", name: "EquityProtect" },
      },
    });

    // 3. Append it to head (or wherever you prefer)
    document.head.appendChild(ldJsonScript);
  }
};

export const injectLocalBusinessSchema = () => {
  if (SERVER === "production") {
    // 1. Create the script element
    const ldJsonScript = document.createElement("script");
    ldJsonScript.type = "application/ld+json";
    ldJsonScript.id = "local-business-schema"; // so we can find/remove it later

    // 2. Populate it with your JSON‑LD
    ldJsonScript.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      name: "EquityProtect",
      image:
        "https://www.equityprotect.com/static/media/equity.425de9cf932b9969560b.WebP",
      "@id": "",
      url: "https://www.equityprotect.com/",
      telephone: "(866) 485-1834",
      address: {
        "@type": "PostalAddress",
        streetAddress: "5566 Longley Ln Suite B",
        addressLocality: "Reno",
        addressRegion: "NV",
        postalCode: "89511",
        addressCountry: "US",
      },
    });

    // 3. Append it to head (or wherever you prefer)
    document.head.appendChild(ldJsonScript);
  }
};

export const injectFAQSchema = () => {
  if (SERVER === "production") {
    // 1. Create the script element
    const ldJsonScript = document.createElement("script");
    ldJsonScript.type = "application/ld+json";
    ldJsonScript.id = "main-faq-schema"; // so we can find/remove it later

    // 2. Populate it with your JSON‑LD
    ldJsonScript.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What is home title fraud, and how does it affect homeowners?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Home title fraud occurs when someone illegally transfers your home ownership or places liens on your property without your knowledge. It can result in financial loss, legal complications, and months of stress to reverse the damage. Learn more about home title theft.",
          },
        },
        {
          "@type": "Question",
          name: "How does EquityProtect differ from other property title lock companies?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Unlike most companies that only monitor your title for fraud, EquityProtect actively protects it using a patented process and blockchain technology. We don’t just notify you after fraud occurs; we prevent it from happening.",
          },
        },
        {
          "@type": "Question",
          name: "What makes your protection service more reliable than standard title monitoring?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Standard title monitoring only informs you after fraud happens, but EquityProtect secures your title using biometric and blockchain technology. We lock down your title, preventing unauthorized transfers or liens.",
          },
        },
        {
          "@type": "Question",
          name: "How does EquityProtect use blockchain to secure my home title?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Blockchain technology creates a secure, tamper-proof record of your home ownership. This prevents unauthorized changes and ensures that only legitimate transactions can be made.",
          },
        },
        {
          "@type": "Question",
          name: "What is the cost of EquityProtect's service compared to other providers?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Other property title lock companies charge approximately $250 per year to JUST MONITOR. In 5 years, you will have spent approximately $1,000 to simply be told that something has or has not occurred on your property. EquityProtect is the only company that provides assurance which provides blockchain protection to your home ownership. We truly protect you from fraud and theft for far less. 5 years of protection will cost less than $680 with EquityProtect.",
          },
        },
        {
          "@type": "Question",
          name: "How quickly does EquityProtect detect and respond to potential fraud?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "EquityProtect monitors your title 24/7, immediately detecting, responding, and preventing any attempts to tamper with your home title or equity.",
          },
        },
        {
          "@type": "Question",
          name: "Is my property monitored 24/7 with EquityProtect?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, EquityProtect provides round-the-clock protection for your property, ensuring real-time monitoring and prevention of any fraudulent activity.",
          },
        },
        {
          "@type": "Question",
          name: "How does EquityProtect validate that I am the rightful owner of my property?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "We use multiple data aggregators to verify your ownership through challenge questions that only you, as the rightful owner, can answer.",
          },
        },
        {
          "@type": "Question",
          name: "How does biometric protection work in your system?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "After setting up your account, we take a headshot using your computer camera or mobile device. This biometric protection ensures that only you can access your account and unlock your title.",
          },
        },
        {
          "@type": "Question",
          name: "Can I protect multiple properties with one EquityProtect account?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, one EquityProtect account can monitor and protect all of your properties.",
          },
        },
        {
          "@type": "Question",
          name: "What happens if someone tries to tamper with my home title while under EquityProtect's protection?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "If an attempt is made to tamper with your title, our system will block it, preventing any unauthorized transfers or liens. You will also be alerted immediately.",
          },
        },
        {
          "@type": "Question",
          name: "How does EquityProtect's facial recognition system ensure security?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Our facial recognition system ensures that only you, the verified homeowner, can authorize changes to your title. This prevents unauthorized access to your property’s records.",
          },
        },
        {
          "@type": "Question",
          name: "What is the process for signing up with EquityProtect?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "The process involves creating an account, verifying your identity and ownership, selecting a subscription plan, and setting up biometric protection, including a headshot and signature.",
          },
        },
        {
          "@type": "Question",
          name: "How does EquityProtect's 'SmartPolicy' insurance coverage work?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Our SmartPolicy covers ALL losses incurred during the time of enrollment PLUS provides extra coverage when you decide to sell or refinance in the future. Decreasing any future title products by up to 75%. Also allows lender to access your SmartPolicy and get a near instant title commitment.",
          },
        },
        {
          "@type": "Question",
          name: "What is included in the final step of the protection process with EquityProtect?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "The final step involves signing your name, which completes the setup and ensures full protection of your title and equity under our system.",
          },
        },
        {
          "@type": "Question",
          name: "How long does it take to activate EquityProtect coverage?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Once your account is set up and your ownership validated, coverage is activated immediately. The entire process takes only a few minutes.",
          },
        },
        {
          "@type": "Question",
          name: "Does EquityProtect provide a free Risk Assessment?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes! All you have to do is fill out the simple, short form on our website. Then, our system will locate your property and pull the most recent title data, and we'll send you your free report. This report will display the current vesting information on your title report. With over 1,100 data points meticulously analyzed, EquityProtect's Risk Assessment Report delivers unparalleled accuracy in evaluating the risk of equity theft and fraud.",
          },
        },
        {
          "@type": "Question",
          name: "What kind of customer support does EquityProtect offer?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "EquityProtect offers dedicated customer support to assist with setup, monitoring, and any issues related to attempted title fraud or theft. Support is available 24/7.",
          },
        },
        {
          "@type": "Question",
          name: "Can I cancel my EquityProtect subscription at any time?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, you can cancel your subscription anytime, though we recommend maintaining continuous coverage to ensure your title remains protected.",
          },
        },
        {
          "@type": "Question",
          name: "What specific types of fraud does EquityProtect protect against?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "EquityProtect safeguards against title fraud, equity theft, and unauthorized liens or transfers. We protect you from any attempts to steal your home ownership or tamper with your title.",
          },
        },
        {
          "@type": "Question",
          name: "How does EquityProtect prevent fraudulent activity before it happens?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "We use a patented process involving blockchain security, facial recognition, and continuous monitoring to lock down your title. This prevents unauthorized access and stops fraudulent actions before they occur.",
          },
        },
        {
          "@type": "Question",
          name: "How does EquityProtect evaluate my risk?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "We cross-reference numerous data points, including ownership patterns, property values, equity percentages, and property data changes, to identify discrepancies or suspicious activity that could signal potential fraud. Our sophisticated algorithms combine these data points to generate a comprehensive risk score, highlighting the likelihood of equity theft or fraud. This allows for targeted protection measures.",
          },
        },
        {
          "@type": "Question",
          name: "What happens if I sell my home while under EquityProtect’s protection?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Once you sell your home, your protection continues until the sale is finalized. You can then easily transfer your EquityProtect coverage to your new property.",
          },
        },
        {
          "@type": "Question",
          name: "Does EquityProtect provide legal assistance in case of fraud?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "If your title is compromised, we offer full legal support to resolve the fraud, including covering legal fees and working with you until the issue is completely rectified.",
          },
        },
        {
          "@type": "Question",
          name: "What could happen if I do not have title protection from EquityProtect?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "You could become a victim of property fraud and deed fraud – meaning your house may be stolen from you. Criminals could then take out loans using your home as collateral. Your home could be listed for rent on popular Classified Ad sites or vacation rental sites. And you could have years of stress (which could have been easily prevented for only a few pennies a day with EquityProtect!)",
          },
        },
        {
          "@type": "Question",
          name: "How secure is the biometric data collected by EquityProtect?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "We take data security very seriously. All biometric data is encrypted and stored securely, ensuring it is only used for verification purposes and protected against unauthorized access.",
          },
        },
        {
          "@type": "Question",
          name: "What should I do if I receive a fraud alert from EquityProtect?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "If you receive a fraud alert, follow the instructions provided in the alert. Our team will work with you to verify the issue and take immediate action to stop any fraudulent activity.",
          },
        },
        {
          "@type": "Question",
          name: "Does EquityProtect cover commercial properties, or is it just for residential homes?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "EquityProtect primarily focuses on residential homes, but depending on the specific circumstances, we may be able to extend coverage to certain types of commercial properties. Contact our team for more details.",
          },
        },
        {
          "@type": "Question",
          name: "How often does EquityProtect update its technology to stay ahead of emerging threats?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "We continuously update our technology to keep up with the latest cybersecurity trends and threats. Our team works tirelessly to ensure that your title is protected against new and evolving forms of fraud.",
          },
        },
        //how-it-works
        {
          "@type": "Question",
          name: "Do you have proof that your ownership is secure and confirmed?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Using multiple different data aggregators, we will verify your home ownership by challenging you with questions only you will know the answer to.",
          },
        },
        {
          "@type": "Question",
          name: "How does EquityProtect safeguard your home title?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Using a patented process, we will lock down your title and protect you from any transfers or new liens.",
          },
        },
        {
          "@type": "Question",
          name: "How do you verify your home title?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Using facial recognition, we will verify who you are and then unlock your property at your request.",
          },
        },
        {
          "@type": "Question",
          name: "Can I Take Action to Protect My Home Equity?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Allowing only specific access to your Real Estate professionals like escrow and lenders, or stop the attempt to tamper with or steal your equity.",
          },
        },
        //Quit Cliam Deed Fraud
        {
          "@type": "Question",
          name: "What Are Quitclaim Deeds?",
          acceptedAnswer: {
            "@type": "Answer",
            text: `Quitclaim deeds are a straightforward way to transfer property interest without the usual assurances about the title's status. Unlike warranty deeds, which confirm the seller's clear ownership, quitclaim deeds simply pass on whatever interest the grantor holds, if any. This makes them handy for transfers where trust is already established, like between family members or during divorce settlements.
                These deeds are typically used when both parties are aware of any title issues, but quitclaim deeds don't guarantee ownership. They don't protect the new owner from future claims, which can open the door to fraud. Unsuspecting buyers might think they're getting full ownership, only to find out later that the grantor had no real interest to transfer.`,
          },
        },
        {
          "@type": "Question",
          name: "Does a Quitclaim Deed Give You Property Ownership?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Many people mistakenly believe a quitclaim deed automatically grants a property full ownership. In reality, it only transfers whatever interest the grantor has without any promises about the title's validity. This means any existing liens or disputes come along with the deed. It also does not guarantee that the grantor has valid ownership of the property. Recipients must conduct a thorough title search to uncover any hidden issues before committing to anything.",
          },
        },
        {
          "@type": "Question",
          name: "How do I recognize Quitclaim Deed Fraud?",
          acceptedAnswer: {
            "@type": "Answer",
            text: `Quitclaim deed fraud is a deceptive practice where individuals exploit the inherent vulnerabilities of quitclaim deeds to transfer property ownership unlawfully. This type of fraud can severely impact property owners, resulting in potential loss of property and costly legal disputes.
                Fraudsters often take advantage of the fact that quitclaim deeds do not guarantee a clear title, making it easier to forge documents or manipulate unsuspecting property owners. In some cases, fraudsters might impersonate legitimate owners or use false identities to execute these fraudulent transfers. Staying informed and vigilant can better protect the individual’s property rights and avoid falling victim to these fraudulent activities.`,
          },
        },
        {
          "@type": "Question",
          name: "How do I prevent Quitclaim Deed Fraud?",
          acceptedAnswer: {
            "@type": "Answer",
            text: `Take some precautions to protect against quitclaim deed fraud if purchasing a property. Conduct a comprehensive title search to identify any existing claims or liens on the property and collaborate with reputable real estate professionals (such as attorneys or title companies) to verify the transaction's legitimacy.
                Confirming the identities of all parties involved can also help prevent fraud. This can be achieved by requesting identification and cross-referencing with official records. Furthermore, consider setting up alerts with local government offices to notify you of any changes or filings related to your property, allowing you to act swiftly if any unauthorized actions are detected.`,
          },
        },
        //Graceland Deed Fraud
        {
          "@type": "Question",
          name: "What is deed fraud?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Deed fraud is when someone illegally transfers property ownership without the real owner's knowledge or consent by forging documents.",
          },
        },
        {
          "@type": "Question",
          name: "Could a historic property like Graceland really be targeted?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. In 2024, scammers nearly auctioned Graceland using fake documents, which underscores that no property is immune.",
          },
        },
        {
          "@type": "Question",
          name: "How does EquityProtect help prevent deed fraud?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "EquityProtect provides preventive monitoring and real-time alerts when suspicious activity is detected in public property records.",
          },
        },
        {
          "@type": "Question",
          name: "Is title insurance enough to protect against deed fraud?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Title insurance typically covers past ownership issues, not future fraud attempts. EquityProtect fills that gap with proactive protection.",
          },
        },
        //Title Insurance vs. EquityProtect
        {
          "@type": "Question",
          name: "What does title insurance cover?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Title insurance typically covers issues such as ownership disputes, liens, or recording errors that occurred prior to your purchase.",
          },
        },
        {
          "@type": "Question",
          name: "Does title insurance protect against new fraud after closing?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Standard policies do not. Enhanced policies may offer limited protection depending on the state and property type.",
          },
        },
        {
          "@type": "Question",
          name: "What does EquityProtect offer that title insurance doesn’t?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "EquityProtect provides preventive monitoring, real-time alerts, and the ability to approve or deny suspicious title changes with a $1 million guarantee.",
          },
        },
        {
          "@type": "Question",
          name: "Can I use both title insurance and EquityProtect?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Title insurance is great for closing-day protection; EquityProtect adds ongoing defense against new fraud after closing.",
          },
        },
      ],
    });

    // 3. Append it to head (or wherever you prefer)
    document.head.appendChild(ldJsonScript);
  }
};
